module.exports = __webpack_public_path__ + "img/terImg1.4197dda5.png";